import { Text } from 'blaze-ui/Text/Text'
import { BlogIntegrationSelect } from 'components/ExternalIntegrationSelect/BlogIntegrationSelect'
import { AlertTriangle } from 'blaze-ui/icons'
import cx from 'classnames'
import Styles from '../../../BlogMetadata.module.scss'

interface BlogMetadataHeaderProps {
  blogIntegrationsCount: number
}

export const BlogMetadataHeader: React.FC<BlogMetadataHeaderProps> = ({ blogIntegrationsCount }) => {
  return (
    <>
      <div className={Styles.descriptionContainer}>
        <Text variant="secondary">
          <span className={Styles.description}>
            Configuring metadata helps improve your blog post's SEO, visibility, and shareability across search engines
            and social media platforms.
          </span>
        </Text>
      </div>
      <div className={Styles.content}>
        <div
          className={cx(Styles.integrationsSelect, {
            [Styles.integrationsSelectNoIntegration]: blogIntegrationsCount === 0,
          })}
        >
          <BlogIntegrationSelect />
          {blogIntegrationsCount === 0 && <AlertTriangle color="var(--red-70)" />}
        </div>
      </div>
    </>
  )
}
